import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionStorageService } from './session-storage.service';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class HandshakeService extends BaseApiService{

  constructor(private http: HttpClient, private localStorageService: SessionStorageService) { 
    super('fortface/v1', localStorageService)
  }

  performHandshake(deviceRequestInfo: any, action?: string): Observable<any> {
    const body = JSON.stringify({ deviceRequestInfo: deviceRequestInfo, action: action});
    
    return this.http.post<any>(this.baseUrl + '/handshake', body,)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Observable<never> {
    // Aqui você pode customizar o tratamento de erros
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro no lado do cliente
      errorMessage = `Erro: ${error.error.message}`;
    } else {
      // Erro no lado do servidor
      errorMessage = `Código do erro: ${error.status}\nMensagem: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

}
